module.exports = __webpack_public_path__ + "static/media/rolex.99c43c5d.jpg";